const getPriceDateOptions = t => {
  return [
    {
      value: 'price_date_1',
      label: t('b.contract.view.price_date_1.label', '1st day of each month')
    },
    {
      value: 'price_date_2',
      label: t('b.contract.view.price_date_2.label', '2nd day of each month')
    },
    {
      value: 'price_date_3',
      label: t('b.contract.view.price_date_3.label', '3rd day of each month')
    },
    {
      value: 'price_date_4',
      label: t('b.contract.view.price_date_4.label', '4th day of each month')
    },
    {
      value: 'price_date_5',
      label: t('b.contract.view.price_date_5.label', '5th day of each month')
    },
    {
      value: 'price_date_6',
      label: t('b.contract.view.price_date_6.label', '6th day of each month')
    },
    {
      value: 'price_date_7',
      label: t('b.contract.view.price_date_7.label', '7th day of each month')
    },
    {
      value: 'price_date_8',
      label: t('b.contract.view.price_date_8.label', '8th day of each month')
    },
    {
      value: 'price_date_9',
      label: t('b.contract.view.price_date_9.label', '9th day of each month')
    },
    {
      value: 'price_date_10',
      label: t('b.contract.view.price_date_10.label', '10th day of each month')
    },
    {
      value: 'price_date_11',
      label: t('b.contract.view.price_date_11.label', '11th day of each month')
    },
    {
      value: 'price_date_12',
      label: t('b.contract.view.price_date_12.label', '12th day of each month')
    },
    {
      value: 'price_date_13',
      label: t('b.contract.view.price_date_13.label', '13th day of each month')
    },
    {
      value: 'price_date_14',
      label: t('b.contract.view.price_date_14.label', '14th day of each month')
    },
    {
      value: 'price_date_15',
      label: t('b.contract.view.price_date_15.label', '15th day of each month')
    },
    {
      value: 'price_date_16',
      label: t('b.contract.view.price_date_16.label', '16th day of each month')
    },
    {
      value: 'price_date_17',
      label: t('b.contract.view.price_date_17.label', '17th day of each month')
    },
    {
      value: 'price_date_18',
      label: t('b.contract.view.price_date_18.label', '18th day of each month')
    },
    {
      value: 'price_date_19',
      label: t('b.contract.view.price_date_19.label', '19th day of each month')
    },
    {
      value: 'price_date_20',
      label: t('b.contract.view.price_date_20.label', '20th day of each month')
    },
    {
      value: 'price_date_21',
      label: t('b.contract.view.price_date_21.label', '21st day of each month')
    },
    {
      value: 'price_date_22',
      label: t('b.contract.view.price_date_22.label', '22nd day of each month')
    },
    {
      value: 'price_date_23',
      label: t('b.contract.view.price_date_23.label', '23rd day of each month')
    },
    {
      value: 'price_date_24',
      label: t('b.contract.view.price_date_24.label', '24th day of each month')
    },
    {
      value: 'price_date_25',
      label: t('b.contract.view.price_date_25.label', '25th day of each month')
    },
    {
      value: 'price_date_26',
      label: t('b.contract.view.price_date_26.label', '26th day of each month')
    },
    {
      value: 'price_date_27',
      label: t('b.contract.view.price_date_27.label', '27th day of each month')
    },
    {
      value: 'price_date_28',
      label: t('b.contract.view.price_date_28.label', '28th day of each month')
    },
    {
      value: 'price_date_29',
      label: t('b.contract.view.price_date_29.label', '29th day of each month')
    },
    {
      value: 'price_date_30',
      label: t('b.contract.view.price_date_30.label', '30th day of each month')
    },
    {
      value: 'price_date_31',
      label: t('b.contract.view.price_date_31.label', '31st day of each month')
    }
  ]
}

export const getWeeklyPriceDateOptions = t => {
  let data = [
    {
      value: 'price_date_1',
      label: t('b.contract.view.weekly_price_date.label', 'Starting on the') + ' 1st'
    },
    {
      value: 'price_date_2',
      label: t('b.contract.view.weekly_price_date.label', 'Starting on the') + ' 2nd'
    },
    {
      value: 'price_date_3',
      label: t('b.contract.view.weekly_price_date.label', 'Starting on the') + ' 3rd'
    }
  ]
  for (let i = 4; i <= 31; i++) {
    data.push({
      value: `price_date_${i}`,
      label: t('b.contract.view.weekly_price_date.label', 'Starting on the') + ` ${i}th`
    })
  }
  return data
}

export default getPriceDateOptions
